import Vue from "vue";
import Component from "vue-class-component";
import LoaderComponent from "@/components/loader/loader.component.vue";
// Services
import CandidateService from "@/core/services/candidate.service.ts";
import ReportService from "@/core/services/report.service.ts";
import { resolveCompanyLogo } from "@/core/constants/fallback-logo";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

@Component({
  components: {
    LoaderComponent,
  },
})
export default class CreateCandidateComponent extends Vue {
  candidateService: any = new CandidateService();
  reportService: any = new ReportService();
  isLoading: boolean = false;
  isSuccess: boolean = false;
  isErrorServer: boolean = false;
  surveyName: string = "";
  name: string = "";
  surname: string = "";
  companies: string = "";
  companiesName: string = "";
  jobs: string = "";
  nameProfile: string = "";
  surveyEndedAt: string = "";

  // effectiveness profile
  sumEffectiveness: number = 0;
  averageEffectiveness: number = 0;
  sumAdministrative: number = 0;
  averageAdministrative: number = 0;
  sumCommunicative: number = 0;
  averageCommunicative: number = 0;
  sumIntegration: number = 0;
  averageIntegration: number = 0;
  sumCognitive: number = 0;
  averageCognitive: number = 0;
  sumIdeal: number = 0;
  averageIdeal: number = 0;
  idealAdministrative: number = 0;
  averageIdealAdministrative: number = 0;
  idealCommunicative: number = 0;
  averageIdealCommunicative: number = 0;
  averageIdealIntegration: number = 0;
  idealCognitive: number = 0;
  averageIdealCognitive: number = 0;

  area1: string = "";
  area2: string = "";
  area3: string = "";
  area4: string = "";
  area5: string = "";
  area6: string = "";
  area7: string = "";
  area8: string = "";
  area9: string = "";
  area10: string = "";
  area11: string = "";
  area12: string = "";
  area13: string = "";
  area14: string = "";

  //competition
  timeManagementE: boolean = false;
  timeManagementS: boolean = false;
  timeManagementP: boolean = false;
  timeManagementR: boolean = false;
  timeManagementD: boolean = false;
  timeManagementM: boolean = false;
  goalsE: boolean = false;
  goalsS: boolean = false;
  goalsP: boolean = false;
  goalsR: boolean = false;
  goalsD: boolean = false;
  goalsM: boolean = false;
  planE: boolean = false;
  planS: boolean = false;
  planP: boolean = false;
  planR: boolean = false;
  planD: boolean = false;
  planM: boolean = false;
  listenOrganizeE: boolean = false;
  listenOrganizeS: boolean = false;
  listenOrganizeP: boolean = false;
  listenOrganizeR: boolean = false;
  listenOrganizeD: boolean = false;
  listenOrganizeM: boolean = false;
  provideInfoE: boolean = false;
  provideInfoS: boolean = false;
  provideInfoP: boolean = false;
  provideInfoR: boolean = false;
  provideInfoD: boolean = false;
  provideInfoM: boolean = false;
  getInfoE: boolean = false;
  getInfoS: boolean = false;
  getInfoP: boolean = false;
  getInfoR: boolean = false;
  getInfoD: boolean = false;
  getInfoM: boolean = false;
  toTrainE: boolean = false;
  toTrainS: boolean = false;
  toTrainP: boolean = false;
  toTrainR: boolean = false;
  toTrainD: boolean = false;
  toTrainM: boolean = false;
  evaluateE: boolean = false;
  evaluateS: boolean = false;
  evaluateP: boolean = false;
  evaluateR: boolean = false;
  evaluateD: boolean = false;
  evaluateM: boolean = false;
  correctE: boolean = false;
  correctS: boolean = false;
  correctP: boolean = false;
  correctR: boolean = false;
  correctD: boolean = false;
  correctM: boolean = false;
  solveProblemsE: boolean = false;
  solveProblemsS: boolean = false;
  solveProblemsP: boolean = false;
  solveProblemsR: boolean = false;
  solveProblemsD: boolean = false;
  solveProblemsM: boolean = false;
  takeDecisionsE: boolean = false;
  takeDecisionsS: boolean = false;
  takeDecisionsP: boolean = false;
  takeDecisionsR: boolean = false;
  takeDecisionsD: boolean = false;
  takeDecisionsM: boolean = false;
  thinkClearlyE: boolean = false;
  thinkClearlyS: boolean = false;
  thinkClearlyP: boolean = false;
  thinkClearlyR: boolean = false;
  thinkClearlyD: boolean = false;
  thinkClearlyM: boolean = false;

  // Leadership Skills
  x: boolean = false;
  y: boolean = false;
  situational: boolean = false;

  // Single percentage
  skillSingle0: number = 0;
  skillSingle1: number = 0;
  skillSingle2: number = 0;
  skillSingle3: number = 0;
  skillSingle4: number = 0;
  skillSingle5: number = 0;
  skillSingle6: number = 0;
  skillSingle7: number = 0;
  skillSingle8: number = 0;
  skillSingle9: number = 0;
  skillSingle10: number = 0;
  skillSingle11: number = 0;
  skillSingle12: number = 0;
  skillSingle13: number = 0;
  skillSingle14: number = 0;
  // Ideal percentage
  skill0: number = 0;
  skill1: number = 0;
  skill2: number = 0;
  skill3: number = 0;
  skill4: number = 0;
  skill5: number = 0;
  skill6: number = 0;
  skill7: number = 0;
  skill8: number = 0;
  skill9: number = 0;
  skill10: number = 0;
  skill11: number = 0;
  skill12: number = 0;
  skill13: number = 0;
  skill14: number = 0;
  // Estilo
  style1: number = 0;

  //** Comunication Style
  comunicationStyleSkill1: number = 0;
  comunicationStyleSkill2: number = 0;
  comunicationStyleSkill3: number = 0;
  comunicationStyleSkill4: number = 0;
  // Position porcentage Comunication
  barPercentageComunication1: number = 0;
  barPercentageComunication2: number = 0;
  barPercentageComunication3: number = 0;
  barPercentageComunication4: number = 0;
  // Width Comunication
  barWidthPercentageComunication1: number = 0;
  barWidthPercentageComunication2: number = 0;
  barWidthPercentageComunication3: number = 0;
  barWidthPercentageComunication4: number = 0;
  //**//

  //** personal Style
  personalStyleSkill1: number = 0;
  personalStyleSkill2: number = 0;
  personalStyleSkill3: number = 0;
  personalStyleSkill4: number = 0;
  // Position porcentage personal
  barPercentagePersonal1: number = 0;
  barPercentagePersonal2: number = 0;
  barPercentagePersonal3: number = 0;
  barPercentagePersonal4: number = 0;
  // Width Personal
  barWidthPercentagePersonal1: number = 0;
  barWidthPercentagePersonal2: number = 0;
  barWidthPercentagePersonal3: number = 0;
  barWidthPercentagePersonal4: number = 0;
  //**//

  //guia de desarrollos
  competition1: boolean = false;
  competition2: boolean = false;
  competition3: boolean = false;
  competition4: boolean = false;
  competition5: boolean = false;
  competition6: boolean = false;
  competition7: boolean = false;
  competition8: boolean = false;
  competition9: boolean = false;
  competition10: boolean = false;
  competition11: boolean = false;
  competition12: boolean = false;
  competition13: boolean = false;

  //Brecha
  totalSkillSingle0: number = 0;
  totalSkillSingle1: number = 0;
  totalSkillSingle2: number = 0;
  totalSkillSingle3: number = 0;
  totalSkillSingle4: number = 0;
  totalSkillSingle5: number = 0;
  totalSkillSingle6: number = 0;
  totalSkillSingle7: number = 0;
  totalSkillSingle8: number = 0;
  totalSkillSingle9: number = 0;
  totalSkillSingle10: number = 0;
  totalSkillSingle11: number = 0;
  totalSkillSingle12: number = 0;
  idealAverageBrecha: number = 0;

  // Styles Sorted Array
  personalSortedArray: any = [];
  communicationSortedArray: any = [];
  skillsSingle: any = [];
  skillsSingleX: any = [];
  skillsSingleY: any = [];

  // External report variables
  anima_old_onResize: any;
  anima_new_onResize: any;
  defaultMaxBarWidth: number = 300;
  barWidthPercentage1: number = 0;
  barWidthPercentage2: number = 0;
  barWidthPercentage3: number = 0;
  barWidthPercentage4: number = 0;
  barWidthPercentage5: number = 0;
  barWidthPercentage6: number = 0;
  barWidthPercentage7: number = 0;
  barWidthPercentage8: number = 0;
  barWidthPercentage9: number = 0;
  barWidthPercentage10: number = 0;
  barWidthPercentage11: number = 0;
  barWidthPercentage12: number = 0;
  barWidthPercentage13: number = 0;
  barWidthPercentage14: number = 0;
  barWidthPercentageEffectiveness: number = 0;
  // Position number bar
  barPercentage1: number = 0;
  barPercentage2: number = 0;
  barPercentage3: number = 0;
  barPercentage4: number = 0;
  barPercentage5: number = 0;
  barPercentage6: number = 0;
  barPercentage7: number = 0;
  barPercentage8: number = 0;
  barPercentage9: number = 0;
  barPercentage10: number = 0;
  barPercentage11: number = 0;
  barPercentage12: number = 0;
  barPercentage13: number = 0;
  barPercentage14: number = 0;
  barPercentageEffectiveness: number = 0;

  //** BRECHA */
  barWidthPercentageBrecha1: number = 0;
  barWidthPercentageBrecha2: number = 0;
  barWidthPercentageBrecha3: number = 0;
  barWidthPercentageBrecha4: number = 0;
  barWidthPercentageBrecha5: number = 0;
  barWidthPercentageBrecha6: number = 0;
  barWidthPercentageBrecha7: number = 0;
  barWidthPercentageBrecha8: number = 0;
  barWidthPercentageBrecha9: number = 0;
  barWidthPercentageBrecha10: number = 0;
  barWidthPercentageBrecha11: number = 0;
  barWidthPercentageBrecha12: number = 0;
  barWidthPercentageBrecha13: number = 0;
  barWidthPercentageBrecha14: number = 0;
  // Position number bar
  barPercentageBrecha1: number = 0;
  barPercentageBrecha2: number = 0;
  barPercentageBrecha3: number = 0;
  barPercentageBrecha4: number = 0;
  barPercentageBrecha5: number = 0;
  barPercentageBrecha6: number = 0;
  barPercentageBrecha7: number = 0;
  barPercentageBrecha8: number = 0;
  barPercentageBrecha9: number = 0;
  barPercentageBrecha10: number = 0;
  barPercentageBrecha11: number = 0;
  barPercentageBrecha12: number = 0;
  barPercentageBrecha13: number = 0;
  barPercentageBrecha14: number = 0;
  // */

  //** IDEAL */
  barWidthPercentageIdeal1: number = 0;
  barWidthPercentageIdeal2: number = 0;
  barWidthPercentageIdeal3: number = 0;
  barWidthPercentageIdeal4: number = 0;
  barWidthPercentageIdeal5: number = 0;
  barWidthPercentageIdeal6: number = 0;
  barWidthPercentageIdeal7: number = 0;
  barWidthPercentageIdeal8: number = 0;
  barWidthPercentageIdeal9: number = 0;
  barWidthPercentageIdeal10: number = 0;
  barWidthPercentageIdeal11: number = 0;
  barWidthPercentageIdeal12: number = 0;
  barWidthPercentageIdeal13: number = 0;
  barWidthPercentageIdeal14: number = 0;
  // Position number bar
  barPercentageIdeal1: number = 0;
  barPercentageIdeal2: number = 0;
  barPercentageIdeal3: number = 0;
  barPercentageIdeal4: number = 0;
  barPercentageIdeal5: number = 0;
  barPercentageIdeal6: number = 0;
  barPercentageIdeal7: number = 0;
  barPercentageIdeal8: number = 0;
  barPercentageIdeal9: number = 0;
  barPercentageIdeal10: number = 0;
  barPercentageIdeal11: number = 0;
  barPercentageIdeal12: number = 0;
  barPercentageIdeal13: number = 0;
  barPercentageIdeal14: number = 0;
  // */
  public leftDefault = 211;

  //** GRAPH BRECHA */
  barGraphBrecha1: number = 0;
  barGraphBrecha2: number = 0;
  barGraphBrecha3: number = 0;
  barGraphBrecha4: number = 0;
  barGraphBrecha5: number = 0;
  barGraphBrecha6: number = 0;
  barGraphBrecha7: number = 0;
  barGraphBrecha8: number = 0;
  barGraphBrecha9: number = 0;
  barGraphBrecha10: number = 0;
  barGraphBrecha11: number = 0;
  barGraphBrecha12: number = 0;
  //  left
  barLeftBrecha1: number = 0;
  barLeftBrecha2: number = 0;
  barLeftBrecha3: number = 0;
  barLeftBrecha4: number = 0;
  barLeftBrecha5: number = 0;
  barLeftBrecha6: number = 0;
  barLeftBrecha7: number = 0;
  barLeftBrecha8: number = 0;
  barLeftBrecha9: number = 0;
  barLeftBrecha10: number = 0;
  barLeftBrecha11: number = 0;
  barLeftBrecha12: number = 0;
  //  left
  percentageBrecha1: number = 0;
  percentageBrecha2: number = 0;
  percentageBrecha3: number = 0;
  percentageBrecha4: number = 0;
  percentageBrecha5: number = 0;
  percentageBrecha6: number = 0;
  percentageBrecha7: number = 0;
  percentageBrecha8: number = 0;
  percentageBrecha9: number = 0;
  percentageBrecha10: number = 0;
  percentageBrecha11: number = 0;
  percentageBrecha12: number = 0;
  barPercentageAdministrative: number = 0;
  barPercentageCommunicative: number = 0;
  barPercentageIntegration: number = 0;
  barPercentageCognitive: number = 0;

  // percentages
  percentageAdministrative: string = "";
  percentageCommunicative: string = "";
  percentageIntegration: string = "";
  percentageCognitive: string = "";

  public logo: string = "";
  public logoIsFallback: boolean = false;
  public companyName: string = "";

  async mounted() {
    const _ = this;
    //  External Report
    _.anima_loadAsyncSrc();
    _.anima_old_onResize = window.onresize;
    _.anima_new_onResize = undefined;
    _.anima_updateOnResize();
    setTimeout(function () {
      _.anima_loadAsyncSrc();
    }, 200);
  }

  async created() {
    const _ = this;
    await _.getProfileReport();
    _.filterDate();
    _.setPagesDynamically();
  }

  anima_updateOnResize() {
    const _ = this;
    if (
      _.anima_new_onResize == undefined ||
      window.onresize != _.anima_new_onResize
    ) {
      _.anima_new_onResize = function (x) {
        // if (_.anima_old_onResize != undefined) _.anima_old_onResize(x);
        _.anima_loadAsyncSrc();
      };
      window.onresize = _.anima_new_onResize;
      setTimeout(function () {
        _.anima_updateOnResize();
      }, 3000);
    }
  }
  // Methods to generate the new report

  anima_isHidden(e) {
    const _ = this;
    if (!(e instanceof HTMLElement)) return !1;
    if (getComputedStyle(e).display == "none") return !0;
    else if (e.parentNode && _.anima_isHidden(e.parentNode)) return !0;
    return !1;
  }
  anima_loadAsyncSrcForTag(tag) {
    const _ = this;
    var elements = document.getElementsByTagName(tag);
    var toLoad = [];
    for (var i = 0; i < elements.length; i++) {
      var e = elements[i];
      var src = e.getAttribute("src");
      var loaded =
        src != undefined &&
        src.length > 0 &&
        src !=
          "data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==";
      if (loaded) continue;
      var asyncSrc = e.getAttribute("anima-src");
      if (asyncSrc == undefined || asyncSrc.length == 0) continue;
      // if (_.anima_old_onResize(e)) continue;
      toLoad.push(e);
    }
    toLoad.sort(function (a, b) {
      return _.anima_getTop(a) - _.anima_getTop(b);
    });
    for (var i = 0; i < toLoad.length; i++) {
      var e = toLoad[i];
      var asyncSrc = e.getAttribute("anima-src");
      e.setAttribute("src", asyncSrc);
    }
  }
  anima_pauseHiddenVideos(tag) {
    const _ = this;
    var elements = document.getElementsByTagName("video");
    for (var i = 0; i < elements.length; i++) {
      var e = elements[i];
      var isPlaying = !!(
        e.currentTime > 0 &&
        !e.paused &&
        !e.ended &&
        e.readyState > 2
      );
      var isHidden = _.anima_old_onResize(e);
      if (!isPlaying && !isHidden && e.getAttribute("autoplay") == "autoplay") {
        e.play();
      } else if (isPlaying && isHidden) {
        e.pause();
      }
    }
  }

  anima_loadAsyncSrc(tag) {
    const _ = this;
    _.anima_loadAsyncSrcForTag("img");
    _.anima_loadAsyncSrcForTag("iframe");
    _.anima_loadAsyncSrcForTag("video");
    _.anima_pauseHiddenVideos();
  }

  anima_getTop(e) {
    var top = 0;
    do {
      top += e.offsetTop || 0;
      e = e.offsetParent;
    } while (e);
    return top;
  }
  // End Reports Methods

  filterDate(date: any = "") {
    const _ = this;
    date = date.split("T");
    date = date[0];
    return date;
  }

  async getProfileReport() {
    const _ = this;
    let userId: any = location.href.split("/");
    userId = userId[4];
    let profileId: any = location.href.split("/");
    profileId = {
      profileId: profileId[6],
    };
    await _.candidateService.getById(userId).then((data: any) => {
      setTimeout(() => {
        _.isLoading = false;
      }, 1500);
      _.name = data["data"].user.name;
      _.surname = data["data"].user.surname;
      const endDate = new Date(data["data"].user.surveys[2].endDate);
      _.surveyEndedAt = endDate.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
      _.companies = data["data"].user.companyId;
      _.companiesName = data["data"].user.company.name;
      _.jobs = data["data"].user.jobId.name;
      const rawLogo = data["data"].user.company.logo;
      _.logo = resolveCompanyLogo(rawLogo);
      _.logoIsFallback = _.logo !== rawLogo;
      _.companyName = data["data"].user.company.name;
    });

    await _.reportService
      .getProfileReport(userId, profileId)
      .then((data: any) => {
        _.nameProfile = data["data"].report.profile.name;
        
        // Determine survey type
        const isMap = data["data"].report.map;
        const isSmap = data["data"].report.smap;
        
        if (isMap && isMap.length > 0) {
          _.surveyName = "MAP";
        }
        
        if (isSmap && isSmap.length > 0) {
          _.surveyName = "SMAP";
        }
        for (
          let i = 0;
          i < data["data"].report.profile.profile_skills.length;
          i++
        ) {
          const currentSkill = data["data"].report.profile.profile_skills[i];
          const currentSkillName =
            data["data"].report.profile.profile_skills[
              i
            ].skill.name.toLowerCase();
          if (currentSkillName === "manejar el tiempo y priorizar") {
            _.skill0 = currentSkill.expectedPercentage;
          }
          if (currentSkillName === "establecer metas y objetivos") {
            _.skill1 = currentSkill.expectedPercentage;
          }
          if (currentSkillName === "planear y programar el trabajo") {
            _.skill2 = currentSkill.expectedPercentage;
          }
          if (currentSkillName === "escuchar y organizar") {
            _.skill3 = currentSkill.expectedPercentage;
          }
          if (currentSkillName === "proporcionar información clara") {
            _.skill4 = currentSkill.expectedPercentage;
          }

          if (currentSkillName === "obtener información específica") {
            _.skill6 = currentSkill.expectedPercentage;
          }

          if (currentSkillName === "entrenar y delegar") {
            _.skill5 = currentSkill.expectedPercentage;
          }
          if (currentSkillName === "evaluar el desempeño de la gente") {
            _.skill7 = currentSkill.expectedPercentage;
          }
          if (currentSkillName === "corregir y aconsejar") {
            _.skill8 = currentSkill.expectedPercentage;
          }
          if (currentSkillName === "identificar y solucionar problemas") {
            _.skill9 = currentSkill.expectedPercentage;
          }
          if (currentSkillName === "tomar decisiones y ponderar riesgos") {
            _.skill10 = currentSkill.expectedPercentage;
          }
          if (currentSkillName === "pensar clara y juiciosamente") {
            _.skill11 = currentSkill.expectedPercentage;
          }
        }
        for (let j = 0; j < data["data"].report.map.length; j++) {
          if (
            data["data"].report.map[j].name
              .toLowerCase()
              .includes("manejar el tiempo y priorizar")
          ) {
            _.skillSingle1 =
              data["data"].report.map[j].result != undefined
                ? data["data"].report.map[j].result.percentage
                : 0;
          }
          if (
            data["data"].report.map[j].name
              .toLowerCase()
              .includes("establecer metas y objetivos")
          ) {
            _.skillSingle2 =
              data["data"].report.map[j].result != undefined
                ? data["data"].report.map[j].result.percentage
                : 0;
          }
          if (
            data["data"].report.map[j].name
              .toLowerCase()
              .includes("planear y programar el trabajo")
          ) {
            _.skillSingle3 =
              data["data"].report.map[j].result != undefined
                ? data["data"].report.map[j].result.percentage
                : 0;
          }
          if (
            data["data"].report.map[j].name
              .toLowerCase()
              .includes("escuchar y organizar")
          ) {
            _.skillSingle4 =
              data["data"].report.map[j].result != undefined
                ? data["data"].report.map[j].result.percentage
                : 0;
          }
          if (
            data["data"].report.map[j].name
              .toLowerCase()
              .includes("proporcionar información clara")
          ) {
            _.skillSingle5 =
              data["data"].report.map[j].result != undefined
                ? data["data"].report.map[j].result.percentage
                : 0;
          }
          if (
            data["data"].report.map[j].name
              .toLowerCase()
              .includes("obtener información específica")
          ) {
            _.skillSingle6 =
              data["data"].report.map[j].result != undefined
                ? data["data"].report.map[j].result.percentage
                : 0;
          }
          if (
            data["data"].report.map[j].name
              .toLowerCase()
              .includes("entrenar y delegar")
          ) {
            _.skillSingle7 =
              data["data"].report.map[j].result != undefined
                ? data["data"].report.map[j].result.percentage
                : 0;
          }
          if (
            data["data"].report.map[j].name
              .toLowerCase()
              .includes("evaluar el desempeño de la gente")
          ) {
            _.skillSingle8 =
              data["data"].report.map[j].result != undefined
                ? data["data"].report.map[j].result.percentage
                : 0;
          }
          if (
            data["data"].report.map[j].name
              .toLowerCase()
              .includes("corregir y aconsejar")
          ) {
            _.skillSingle9 =
              data["data"].report.map[j].result != undefined
                ? data["data"].report.map[j].result.percentage
                : 0;
          }
          if (
            data["data"].report.map[j].name
              .toLowerCase()
              .includes("identificar y solucionar problemas")
          ) {
            _.skillSingle10 =
              data["data"].report.map[j].result != undefined
                ? data["data"].report.map[j].result.percentage
                : 0;
          }
          if (
            data["data"].report.map[j].name
              .toLowerCase()
              .includes("tomar decisiones y ponderar riesgos")
          ) {
            _.skillSingle11 =
              data["data"].report.map[j].result != undefined
                ? data["data"].report.map[j].result.percentage
                : 0;
          }
          if (
            data["data"].report.map[j].name
              .toLowerCase()
              .includes("pensar clara y juiciosamente")
          ) {
            _.skillSingle12 =
              data["data"].report.map[j].result != undefined
                ? data["data"].report.map[j].result.percentage
                : 0;
          }
          if (data["data"].report.map[j].name.toLowerCase().includes("x")) {
            _.skillSingle13 =
              data["data"].report.map[j].result != undefined
                ? data["data"].report.map[j].result.percentage
                : 0;
          }
          if (data["data"].report.map[j].name.toLowerCase().includes("y")) {
            _.skillSingle14 =
              data["data"].report.map[j].result != undefined
                ? data["data"].report.map[j].result.percentage
                : 0;
          }
        }
        if (_.skillSingle13 > _.skillSingle14) {
          _.x = true;
          _.y = false;
        }
        if (_.skillSingle14 > _.skillSingle13) {
          _.y = true;
          _.x = false;
        }
        if (_.skillSingle14 > 70 && _.skillSingle13 > 70) {
          _.x = false;
          _.y = false;
          _.situational = true;
        }
        if (_.skillSingle1 <= 15) {
          _.area1 = "Marginal";
          _.timeManagementM = true;
        }
        if (_.skillSingle1 >= 16 && _.skillSingle1 <= 30) {
          _.area1 = "Deficiente";
          _.timeManagementD = true;
        }
        if (_.skillSingle1 >= 31 && _.skillSingle1 <= 50) {
          _.area1 = "Regular";
          _.timeManagementR = true;
        }
        if (_.skillSingle1 >= 51 && _.skillSingle1 <= 70) {
          _.area1 = "Promedio";
          _.timeManagementP = true;
        }
        if (_.skillSingle1 >= 71 && _.skillSingle1 <= 85) {
          _.area1 = "Superior";
          _.timeManagementS = true;
        }
        if (_.skillSingle1 >= 86) {
          _.area1 = "Excelente";
          _.timeManagementE = true;
        }
        if (_.skillSingle2 <= 15) {
          _.area2 = "Marginal";
          _.goalsM = true;
        }
        if (_.skillSingle2 >= 16 && _.skillSingle2 <= 30) {
          _.area2 = "Deficiente";
          _.goalsD = true;
        }
        if (_.skillSingle2 >= 31 && _.skillSingle2 <= 50) {
          _.area2 = "Regular";
          _.goalsR = true;
        }
        if (_.skillSingle2 >= 51 && _.skillSingle2 <= 70) {
          _.area2 = "Promedio";
          _.goalsP = true;
        }
        if (_.skillSingle2 >= 71 && _.skillSingle2 <= 85) {
          _.area2 = "Superior";
          _.goalsS = true;
        }
        if (_.skillSingle2 >= 86) {
          _.area2 = "Excelente";
          _.goalsE = true;
        }
        if (_.skillSingle3 <= 15) {
          _.area3 = "Marginal";
          _.planM = true;
        }
        if (_.skillSingle3 >= 16 && _.skillSingle3 <= 30) {
          _.area3 = "Deficiente";
          _.planD = true;
        }
        if (_.skillSingle3 >= 31 && _.skillSingle3 <= 50) {
          _.area3 = "Regular";
          _.planR = true;
        }
        if (_.skillSingle3 >= 51 && _.skillSingle3 <= 70) {
          _.area3 = "Promedio";
          _.planP = true;
        }
        if (_.skillSingle3 >= 71 && _.skillSingle3 <= 85) {
          _.area3 = "Superior";
          _.planS = true;
        }
        if (_.skillSingle3 >= 86) {
          _.area3 = "Excelente";
          _.planE = true;
        }
        if (_.skillSingle4 <= 15) {
          _.area4 = "Marginal";
          _.listenOrganizeM = true;
        }
        if (_.skillSingle4 >= 16 && _.skillSingle4 <= 30) {
          _.area4 = "Deficiente";
          _.listenOrganizeD = true;
        }
        if (_.skillSingle4 >= 31 && _.skillSingle4 <= 50) {
          _.area4 = "Regular";
          _.listenOrganizeR = true;
        }
        if (_.skillSingle4 >= 51 && _.skillSingle4 <= 70) {
          _.area4 = "Promedio";
          _.listenOrganizeP = true;
        }
        if (_.skillSingle4 >= 71 && _.skillSingle4 <= 85) {
          _.area4 = "Superior";
          _.listenOrganizeS = true;
        }
        if (_.skillSingle4 >= 86) {
          _.area4 = "Excelente";
          _.listenOrganizeE = true;
        }
        if (_.skillSingle5 <= 15) {
          _.area5 = "Marginal";
          _.provideInfoM = true;
        }
        if (_.skillSingle5 >= 16 && _.skillSingle5 <= 30) {
          _.area5 = "Deficiente";
          _.provideInfoD = true;
        }
        if (_.skillSingle5 >= 31 && _.skillSingle5 <= 50) {
          _.area5 = "Regular";
          _.provideInfoR = true;
        }
        if (_.skillSingle5 >= 51 && _.skillSingle5 <= 70) {
          _.area5 = "Promedio";
          _.provideInfoP = true;
        }
        if (_.skillSingle5 >= 71 && _.skillSingle5 <= 85) {
          _.area5 = "Superior";
          _.provideInfoS = true;
        }
        if (_.skillSingle5 >= 86) {
          _.area5 = "Excelente";
          _.provideInfoE = true;
        }
        if (_.skillSingle6 <= 15) {
          _.area6 = "Marginal";
          _.getInfoM = true;
        }
        if (_.skillSingle6 >= 16 && _.skillSingle6 <= 30) {
          _.area6 = "Deficiente";
          _.getInfoD = true;
        }
        if (_.skillSingle6 >= 31 && _.skillSingle6 <= 50) {
          _.area6 = "Regular";
          _.getInfoR = true;
        }
        if (_.skillSingle6 >= 51 && _.skillSingle6 <= 70) {
          _.area6 = "Promedio";
          _.getInfoP = true;
        }
        if (_.skillSingle6 >= 71 && _.skillSingle6 <= 85) {
          _.area6 = "Superior";
          _.getInfoS = true;
        }
        if (_.skillSingle6 >= 86) {
          _.area6 = "Excelente";
          _.getInfoE = true;
        }
        if (_.skillSingle7 <= 15) {
          _.area7 = "Marginal";
          _.toTrainM = true;
        }
        if (_.skillSingle7 >= 16 && _.skillSingle7 <= 30) {
          _.area7 = "Deficiente";
          _.toTrainD = true;
        }
        if (_.skillSingle7 >= 31 && _.skillSingle7 <= 50) {
          _.area7 = "Regular";
          _.toTrainR = true;
        }
        if (_.skillSingle7 >= 51 && _.skillSingle7 <= 70) {
          _.area7 = "Promedio";
          _.toTrainP = true;
        }
        if (_.skillSingle7 >= 71 && _.skillSingle7 <= 85) {
          _.area7 = "Superior";
          _.toTrainS = true;
        }
        if (_.skillSingle7 >= 86) {
          _.area7 = "Excelente";
          _.toTrainE = true;
        }
        if (_.skillSingle8 <= 15) {
          _.area8 = "Marginal";
          _.evaluateM = true;
        }
        if (_.skillSingle8 >= 16 && _.skillSingle8 <= 30) {
          _.area8 = "Deficiente";
          _.evaluateD = true;
        }
        if (_.skillSingle8 >= 31 && _.skillSingle8 <= 50) {
          _.area8 = "Regular";
          _.evaluateR = true;
        }
        if (_.skillSingle8 >= 51 && _.skillSingle8 <= 70) {
          _.area8 = "Promedio";
          _.evaluateP = true;
        }
        if (_.skillSingle8 >= 71 && _.skillSingle8 <= 85) {
          _.area8 = "Superior";
          _.evaluateS = true;
        }
        if (_.skillSingle8 >= 86) {
          _.area8 = "Excelente";
          _.evaluateE = true;
        }
        if (_.skillSingle9 <= 15) {
          _.area9 = "Marginal";
          _.correctM = true;
        }
        if (_.skillSingle9 >= 16 && _.skillSingle9 <= 30) {
          _.area9 = "Deficiente";
          _.correctD = true;
        }
        if (_.skillSingle9 >= 31 && _.skillSingle9 <= 50) {
          _.area9 = "Regular";
          _.correctR = true;
        }
        if (_.skillSingle9 >= 51 && _.skillSingle9 <= 70) {
          _.area9 = "Promedio";
          _.correctP = true;
        }
        if (_.skillSingle9 >= 71 && _.skillSingle9 <= 85) {
          _.area9 = "Superior";
          _.correctS = true;
        }
        if (_.skillSingle9 >= 86) {
          _.area9 = "Excelente";
          _.correctE = true;
        }
        if (_.skillSingle10 <= 15) {
          _.area10 = "Marginal";
          _.solveProblemsM = true;
        }
        if (_.skillSingle10 >= 16 && _.skillSingle10 <= 30) {
          _.area10 = "Deficiente";
          _.solveProblemsD = true;
        }
        if (_.skillSingle10 >= 31 && _.skillSingle10 <= 50) {
          _.area10 = "Regular";
          _.solveProblemsR = true;
        }
        if (_.skillSingle10 >= 51 && _.skillSingle10 <= 70) {
          _.area10 = "Promedio";
          _.solveProblemsP = true;
        }
        if (_.skillSingle10 >= 71 && _.skillSingle10 <= 85) {
          _.area10 = "Superior";
          _.solveProblemsS = true;
        }
        if (_.skillSingle10 >= 86) {
          _.area10 = "Excelente";
          _.solveProblemsE = true;
        }
        if (_.skillSingle11 <= 15) {
          _.area11 = "Marginal";
          _.takeDecisionsM = true;
        }
        if (_.skillSingle11 >= 16 && _.skillSingle11 <= 30) {
          _.area11 = "Deficiente";
          _.takeDecisionsD = true;
        }
        if (_.skillSingle11 >= 31 && _.skillSingle11 <= 50) {
          _.area11 = "Regular";
          _.takeDecisionsR = true;
        }
        if (_.skillSingle11 >= 51 && _.skillSingle11 <= 70) {
          _.area11 = "Promedio";
          _.takeDecisionsP = true;
        }
        if (_.skillSingle11 >= 71 && _.skillSingle11 <= 85) {
          _.area11 = "Superior";
          _.takeDecisionsS = true;
        }
        if (_.skillSingle11 >= 86) {
          _.area11 = "Excelente";
          _.takeDecisionsE = true;
        }
        if (_.skillSingle12 <= 15) {
          _.area12 = "Marginal";
          _.thinkClearlyM = true;
        }
        if (_.skillSingle12 >= 16 && _.skillSingle12 <= 30) {
          _.area12 = "Deficiente";
          _.thinkClearlyD = true;
        }
        if (_.skillSingle12 >= 31 && _.skillSingle12 <= 50) {
          _.area12 = "Regular";
          _.thinkClearlyR = true;
        }
        if (_.skillSingle12 >= 51 && _.skillSingle12 <= 70) {
          _.area12 = "Promedio";
          _.thinkClearlyP = true;
        }
        if (_.skillSingle12 >= 71 && _.skillSingle12 <= 85) {
          _.area12 = "Superior";
          _.thinkClearlyS = true;
        }
        if (_.skillSingle12 >= 86) {
          _.area12 = "Excelente";
          _.thinkClearlyE = true;
        }
        if (_.skillSingle13 <= 15) {
          _.area13 = "Marginal";
        }
        if (_.skillSingle13 >= 16 && _.skillSingle13 <= 30) {
          _.area13 = "Deficiente";
        }
        if (_.skillSingle13 >= 31 && _.skillSingle13 <= 50) {
          _.area13 = "Regular";
        }
        if (_.skillSingle13 >= 51 && _.skillSingle13 <= 70) {
          _.area13 = "Promedio";
        }
        if (_.skillSingle13 >= 71 && _.skillSingle13 <= 85) {
          _.area13 = "Superior";
        }
        if (_.skillSingle13 >= 86) {
          _.area13 = "Excelente";
        }

        if (_.skillSingle14 <= 15) {
          _.area14 = "Marginal";
        }
        if (_.skillSingle14 >= 16 && _.skillSingle14 <= 30) {
          _.area14 = "Deficiente";
        }
        if (_.skillSingle14 >= 31 && _.skillSingle14 <= 50) {
          _.area14 = "Regular";
        }
        if (_.skillSingle14 >= 51 && _.skillSingle14 <= 70) {
          _.area14 = "Promedio";
        }
        if (_.skillSingle14 >= 71 && _.skillSingle14 <= 85) {
          _.area14 = "Superior";
        }
        if (_.skillSingle14 >= 86) {
          _.area14 = "Excelente";
        }

        //effectiveness profile
        _.sumEffectiveness =
          _.skillSingle1 +
          _.skillSingle2 +
          _.skillSingle3 +
          _.skillSingle4 +
          _.skillSingle5 +
          _.skillSingle6 +
          _.skillSingle7 +
          _.skillSingle8 +
          _.skillSingle9 +
          _.skillSingle10 +
          _.skillSingle11 +
          _.skillSingle12;
        _.averageEffectiveness = (_.sumEffectiveness / 12).toFixed(0);

        //administrative
        _.sumAdministrative = _.skillSingle1 + _.skillSingle2 + _.skillSingle3;
        _.averageAdministrative = (_.sumAdministrative / 3).toFixed(0);
        _.barPercentageAdministrative = 407 + _.sumAdministrative / 3;

        //communicative
        _.sumCommunicative = _.skillSingle4 + _.skillSingle5 + _.skillSingle6;
        _.averageCommunicative = (_.sumCommunicative / 3).toFixed(0);
        _.barPercentageCommunicative = 407 + _.sumCommunicative / 3;

        //Integration
        _.sumIntegration = _.skillSingle7 + _.skillSingle8 + _.skillSingle9;
        _.averageIntegration = (_.sumIntegration / 3).toFixed(0);
        _.barPercentageIntegration = 407 + _.sumIntegration / 3;

        //Cognitive
        _.sumCognitive = _.skillSingle10 + _.skillSingle11 + _.skillSingle12;
        _.averageCognitive = (_.sumCognitive / 3).toFixed(0);
        _.barPercentageCognitive = 407 + _.sumCognitive / 3;

        // profile ideal
        _.sumIdeal =
          _.skill0 +
          _.skill1 +
          _.skill2 +
          _.skill3 +
          _.skill4 +
          _.skill5 +
          _.skill6 +
          _.skill7 +
          _.skill8 +
          _.skill9 +
          _.skill10 +
          _.skill11;
        _.averageIdeal = (_.sumIdeal / 12).toFixed(0);
        //administrative
        _.idealAdministrative = _.skill0 + _.skill1 + _.skill2;
        _.averageIdealAdministrative = (_.idealAdministrative / 3).toFixed(0);
        _.percentageAdministrative = (
          (_.averageAdministrative * 100) / _.averageIdealAdministrative -
          100
        ).toFixed(0);
        //communicative
        _.idealCommunicative = _.skill3 + _.skill4 + _.skill6;
        _.averageIdealCommunicative = (_.idealCommunicative / 3).toFixed(0);
        _.percentageCommunicative = (
          (_.averageCommunicative * 100) / _.averageIdealCommunicative -
          100
        ).toFixed(0);
        //Integration
        _.idealIntegration = _.skill5 + _.skill7 + _.skill8;
        _.averageIdealIntegration = (_.idealIntegration / 3).toFixed(0);
        _.percentageIntegration = (
          (_.averageIntegration * 100) / _.averageIdealIntegration -
          100
        ).toFixed(0);
        //Cognitive
        _.idealCognitive = _.skill9 + _.skill10 + _.skill11;
        _.averageIdealCognitive = (_.idealCognitive / 3).toFixed(0);
        _.percentageCognitive = (
          (_.averageCognitive * 100) / _.averageIdealCognitive -
          100
        ).toFixed(0);

        //brecha
        _.totalSkillSingle1 = (
          isNaN((_.skillSingle1 * 100) / _.skill0)
            ? 100
            : (_.skillSingle1 * 100) / _.skill0 - 100
        ).toFixed(0);
        _.totalSkillSingle2 = (
          isNaN((_.skillSingle2 * 100) / _.skill1)
            ? 0
            : (_.skillSingle2 * 100) / _.skill1 - 100
        ).toFixed(0);
        _.totalSkillSingle3 = (
          isNaN((_.skillSingle3 * 100) / _.skill2)
            ? 0
            : (_.skillSingle3 * 100) / _.skill2 - 100
        ).toFixed(0);
        _.totalSkillSingle4 = (
          isNaN((_.skillSingle4 * 100) / _.skill3)
            ? 0
            : (_.skillSingle4 * 100) / _.skill3 - 100
        ).toFixed(0);

        _.totalSkillSingle5 = (
          _.skill4 !== 0 ? (_.skillSingle5 * 100) / _.skill4 - 100 : 0
        ).toFixed(0);

        _.totalSkillSingle6 = (
          _.skill6 !== 0 ? (_.skillSingle6 * 100) / _.skill6 - 100 : 0
        ).toFixed(0);

        _.totalSkillSingle7 = (
          _.skill5 !== 0 ? (_.skillSingle7 * 100) / _.skill5 - 100 : 0
        ).toFixed(0);

        _.totalSkillSingle8 = (
          _.skill7 !== 0 ? (_.skillSingle8 * 100) / _.skill7 - 100 : 0
        ).toFixed(0);

        _.totalSkillSingle9 = (
          _.skill8 !== 0 ? (_.skillSingle9 * 100) / _.skill8 - 100 : 0
        ).toFixed(0);

        _.totalSkillSingle10 = (
          _.skill9 !== 0 ? (_.skillSingle10 * 100) / _.skill9 - 100 : 0
        ).toFixed(0);

        _.totalSkillSingle11 = (
          _.skill10 !== 0 ? (_.skillSingle11 * 100) / _.skill10 - 100 : 0
        ).toFixed(0);

        _.totalSkillSingle12 = (
          _.skill11 !== 0 ? (_.skillSingle12 * 100) / _.skill11 - 100 : 0
        ).toFixed(0);

        _.idealAverageBrecha = (
          isNaN((_.averageEffectiveness * 100) / _.averageIdeal)
            ? 0
            : (_.averageEffectiveness * 100) / _.averageIdeal - 100
        ).toFixed(0);

        // graph brecha
        const defaultMaxbrechaWidth = 38;
        const leftBrechaMax = 211;
        const leftBrechaMin = 173;
        const defaultBrechaLeft = 205;

        if (_.totalSkillSingle1 > 0) {
          _.barGraphBrecha1 =
            (_.totalSkillSingle1 * defaultMaxbrechaWidth) / 50;
          _.barLeftBrecha1 = leftBrechaMax;
          _.percentageBrecha1 = _.barGraphBrecha1 + defaultBrechaLeft;
          if (_.barGraphBrecha1 > 38) {
            _.percentageBrecha1 = 247;
          }
        } else {
          const negative = _.totalSkillSingle1 * -1;
          _.barGraphBrecha1 = (negative * defaultMaxbrechaWidth) / 50;
          _.barLeftBrecha1 = leftBrechaMin;
          _.percentageBrecha1 = 212;
        }

        if (_.totalSkillSingle2 > 0) {
          _.barGraphBrecha2 =
            (_.totalSkillSingle2 * defaultMaxbrechaWidth) / 50;
          _.barLeftBrecha2 = leftBrechaMax;
          _.percentageBrecha2 = _.barGraphBrecha2 + defaultBrechaLeft;
          if (_.barGraphBrecha2 > 38) {
            _.percentageBrecha2 = 247;
          }
        } else {
          const negative = _.totalSkillSingle2 * -1;
          _.barGraphBrecha2 = (negative * defaultMaxbrechaWidth) / 50;
          _.barLeftBrecha2 = leftBrechaMin;
          _.percentageBrecha2 = 212;
        }

        if (_.totalSkillSingle3 >= 0) {
          _.barGraphBrecha3 =
            (_.totalSkillSingle3 * defaultMaxbrechaWidth) / 50;
          _.barLeftBrecha3 = leftBrechaMax;
          _.percentageBrecha3 = _.barGraphBrecha3 + defaultBrechaLeft;
          if (_.barGraphBrecha3 > 38) {
            _.percentageBrecha3 = 247;
          }
        } else {
          const negative = _.totalSkillSingle3 * -1;
          _.barGraphBrecha3 = (negative * defaultMaxbrechaWidth) / 50;
          _.barLeftBrecha3 = leftBrechaMin;
          _.percentageBrecha3 = 212;
        }

        if (_.totalSkillSingle4 >= 0) {
          _.barGraphBrecha4 =
            (_.totalSkillSingle4 * defaultMaxbrechaWidth) / 50;
          _.barLeftBrecha4 = leftBrechaMax;
          _.percentageBrecha4 = _.barGraphBrecha4 + defaultBrechaLeft;
          if (_.barGraphBrecha4 > 38) {
            _.percentageBrecha4 = 247;
          }
        } else {
          const negative = _.totalSkillSingle4 * -1;
          _.barGraphBrecha4 = (negative * defaultMaxbrechaWidth) / 50;
          _.barLeftBrecha4 = leftBrechaMin;
          _.percentageBrecha4 = 212;
        }

        if (_.totalSkillSingle5 >= 0) {
          _.barGraphBrecha5 =
            (_.totalSkillSingle5 * defaultMaxbrechaWidth) / 50;
          _.barLeftBrecha5 = leftBrechaMax;
          _.percentageBrecha5 = _.barGraphBrecha5 + defaultBrechaLeft;
          if (_.barGraphBrecha5 > 38) {
            _.percentageBrecha5 = 247;
          }
        } else {
          const negative = _.totalSkillSingle5 * -1;
          _.barGraphBrecha5 = (negative * defaultMaxbrechaWidth) / 50;
          _.barLeftBrecha5 = leftBrechaMin;
          _.percentageBrecha5 = 212;
        }

        if (_.totalSkillSingle6 >= 0) {
          _.barGraphBrecha6 =
            (_.totalSkillSingle6 * defaultMaxbrechaWidth) / 50;
          _.barLeftBrecha6 = leftBrechaMax;
          _.percentageBrecha6 = _.barGraphBrecha6 + defaultBrechaLeft;
          if (_.barGraphBrecha6 > 38) {
            _.percentageBrecha6 = 247;
          }
        } else {
          const negative = _.totalSkillSingle6 * -1;
          _.barGraphBrecha6 = (negative * defaultMaxbrechaWidth) / 50;
          _.barLeftBrecha6 = leftBrechaMin;
          _.percentageBrecha6 = 212;
        }

        if (_.totalSkillSingle7 >= 0) {
          _.barGraphBrecha7 =
            (_.totalSkillSingle7 * defaultMaxbrechaWidth) / 50;
          _.barLeftBrecha7 = leftBrechaMax;
          _.percentageBrecha7 = _.barGraphBrecha7 + defaultBrechaLeft;
          if (_.barGraphBrecha7 > 38) {
            _.percentageBrecha7 = 247;
          }
        } else {
          const negative = _.totalSkillSingle7 * -1;
          _.barGraphBrecha7 = (negative * defaultMaxbrechaWidth) / 50;
          _.barLeftBrecha7 = leftBrechaMin;
          _.percentageBrecha7 = 212;
        }

        if (_.totalSkillSingle8 >= 0) {
          _.barGraphBrecha8 =
            (_.totalSkillSingle8 * defaultMaxbrechaWidth) / 50;
          _.barLeftBrecha8 = leftBrechaMax;
          _.percentageBrecha8 = _.barGraphBrecha8 + defaultBrechaLeft;
          if (_.barGraphBrecha8 > 38) {
            _.percentageBrecha8 = 247;
          }
        } else {
          const negative = _.totalSkillSingle8 * -1;
          _.barGraphBrecha8 = (negative * defaultMaxbrechaWidth) / 50;
          _.barLeftBrecha8 = leftBrechaMin;
          _.percentageBrecha8 = 212;
        }

        if (_.totalSkillSingle9 >= 0) {
          _.barGraphBrecha9 =
            (_.totalSkillSingle9 * defaultMaxbrechaWidth) / 50;
          _.barLeftBrecha9 = leftBrechaMax;
          _.percentageBrecha9 = _.barGraphBrecha9 + defaultBrechaLeft;
          if (_.barGraphBrecha9 > 38) {
            _.percentageBrecha9 = 247;
          }
        } else {
          const negative = _.totalSkillSingle9 * -1;
          _.barGraphBrecha9 = (negative * defaultMaxbrechaWidth) / 50;
          _.barLeftBrecha9 = leftBrechaMin;
          _.percentageBrecha9 = 212;
        }

        if (_.totalSkillSingle10 >= 0) {
          _.barGraphBrecha10 =
            (_.totalSkillSingle10 * defaultMaxbrechaWidth) / 50;
          _.barLeftBrecha10 = leftBrechaMax;
          _.percentageBrecha10 = _.barGraphBrecha10 + defaultBrechaLeft;
          if (_.barGraphBrecha10 > 38) {
            _.percentageBrecha10 = 247;
          }
        } else {
          const negative = _.totalSkillSingle10 * -1;
          _.barGraphBrecha10 = (negative * defaultMaxbrechaWidth) / 50;
          _.barLeftBrecha10 = leftBrechaMin;
          _.percentageBrecha10 = 212;
        }

        if (_.totalSkillSingle11 >= 0) {
          _.barGraphBrecha11 =
            (_.totalSkillSingle11 * defaultMaxbrechaWidth) / 50;
          _.barLeftBrecha11 = leftBrechaMax;
          _.percentageBrecha11 = _.barGraphBrecha11 + defaultBrechaLeft;
          if (_.barGraphBrecha11 > 38) {
            _.percentageBrecha11 = 247;
          }
        } else {
          const negative = _.totalSkillSingle11 * -1;
          _.barGraphBrecha11 = (negative * defaultMaxbrechaWidth) / 50;
          _.barLeftBrecha11 = leftBrechaMin;
          _.percentageBrecha11 = 212;
        }

        if (_.totalSkillSingle12 >= 0) {
          _.barGraphBrecha12 =
            (_.totalSkillSingle12 * defaultMaxbrechaWidth) / 50;
          _.barLeftBrecha12 = leftBrechaMax;
          _.percentageBrecha12 = _.barGraphBrecha12 + defaultBrechaLeft;
          if (_.barGraphBrecha12 > 38) {
            _.percentageBrecha12 = 247;
          }
        } else {
          const negative = _.totalSkillSingle12 * -1;
          _.barGraphBrecha12 = (negative * defaultMaxbrechaWidth) / 50;
          _.barLeftBrecha12 = leftBrechaMin;
          _.percentageBrecha12 = 212;
        }

        // For to get personal skills
        for (let k = 0; k < data["data"].report.auto.length; k++) {
          if (data["data"].report.auto[k].name.includes("Analítico")) {
            _.barWidthPercentagePersonal1 =
              (data["data"].report.auto[k].score * 355) / 100;
            _.barPercentagePersonal1 =
              _.barWidthPercentagePersonal1 + _.leftDefault;
            _.personalStyleSkill1 = data["data"].report.auto[k].score;
          }
          if (data["data"].report.auto[k].name.includes("Creativo")) {
            _.barWidthPercentagePersonal2 =
              (data["data"].report.auto[k].score * 355) / 100;
            _.barPercentagePersonal2 =
              _.barWidthPercentagePersonal2 + _.leftDefault;
            _.personalStyleSkill2 = data["data"].report.auto[k].score;
          }
          if (data["data"].report.auto[k].name.includes("Activo")) {
            _.barWidthPercentagePersonal3 =
              (data["data"].report.auto[k].score * 355) / 100;
            _.barPercentagePersonal3 =
              _.barWidthPercentagePersonal3 + _.leftDefault;
            _.personalStyleSkill3 = data["data"].report.auto[k].score;
          }
          if (data["data"].report.auto[k].name.includes("Sensible")) {
            _.barWidthPercentagePersonal4 =
              (data["data"].report.auto[k].score * 355) / 100;
            _.barPercentagePersonal4 =
              _.barWidthPercentagePersonal4 + _.leftDefault;
            _.personalStyleSkill4 = data["data"].report.auto[k].score;
          }
        }
        // For to get communication skills
        for (let k = 0; k < data["data"].report.communication.length; k++) {
          if (data["data"].report.communication[k].name.includes("Empático")) {
            _.barWidthPercentageComunication1 =
              (data["data"].report.communication[k].score *
                558) /
              100;
            _.barPercentageComunication1 =
              _.barWidthPercentageComunication1 + _.leftDefault;
            _.comunicationStyleSkill1 =
              data["data"].report.communication[k].score;
          }
          if (data["data"].report.communication[k].name.includes("Crítico")) {
            _.barWidthPercentageComunication2 =
              (data["data"].report.communication[k].score *
                558) /
              100;
            _.barPercentageComunication2 =
              _.barWidthPercentageComunication2 + _.leftDefault;
            _.comunicationStyleSkill2 =
              data["data"].report.communication[k].score;
          }
          if (
            data["data"].report.communication[k].name.includes("Inquisitivo")
          ) {
            _.barWidthPercentageComunication3 =
              (data["data"].report.communication[k].score *
                558) /
              100;
            _.barPercentageComunication3 =
              _.barWidthPercentageComunication3 + _.leftDefault;
            _.comunicationStyleSkill3 =
              data["data"].report.communication[k].score;
          }
          if (data["data"].report.communication[k].name.includes("Consejero")) {
            _.barWidthPercentageComunication4 =
              (data["data"].report.communication[k].score *
                558) /
              100;
            _.barPercentageComunication4 =
              _.barWidthPercentageComunication4 + _.leftDefault;
            _.comunicationStyleSkill4 =
              data["data"].report.communication[k].score;
          }
        }

        // Sort personal skills
        _.personalSortedArray = data["data"].report.auto;
        _.personalSortedArray.sort((a, b) => {
          return a.score < b.score ? 1 : -1;
        });

        //Sort communication skills
        _.communicationSortedArray = data["data"].report.communication;
        _.communicationSortedArray.sort((a, b) => {
          return a.score < b.score ? 1 : -1;
        });
        _.skillsSingle = data["data"].report.map;

        _.skillsSingle = _.skillsSingle.filter((data) => {
          return data.name !== "X" && data.name !== "Y";
        });
        _.skillsSingle = _.skillsSingle.filter((data) => {
          return data.result !== undefined && data.result !== null;
        });
        _.skillsSingle.sort((a, b) => {
          return a.result.percentage > b.result.percentage ? 1 : -1;
        });
        _.getPercentageBarWidth();
      })
      .catch((err) => {
        console.log(err, " Error getting report data");
      });
    _.listenLoadedImgs();
    // _.printReport();
  }

  listenLoadedImgs() {
    const _ = this;
    const trainingLogo = document.querySelector(
      "img.trainingtechnologies"
    ) as HTMLImageElement;
    const hasUserInfoLoaded = this.name && this.surname && this.companyName;
    const mapLogo = document.querySelector("img.mapc") as HTMLImageElement;
    const isReadyToPrint =
      trainingLogo.complete && mapLogo.complete && hasUserInfoLoaded;
    let loadedIntervalReview: any;
    loadedIntervalReview = setInterval(() => {
      clearInterval(loadedIntervalReview);
      _.reportToPDF();
    }, 1000);
  }

  private async reportToPDF() {
    console.log("Report to PDF");
    const pdfDoc = new jsPDF("p", "mm", "a4");
    // Guide blocks are hardcoded in template order, so when the weakest
    // competencia's block sits after the other one the guides would print
    // swapped; reorder the captured pages (not the DOM — Vue re-renders
    // would patch footers into the wrong wrappers) so guide 1 prints first.
    const guideBlockDomOrder = [
      "Identificar y Solucionar Problemas",
      "Corregir y Aconsejar",
      "Obtener Información Específica",
      "Planear y Programar el Trabajo",
      "Escuchar y Organizar",
      "Evaluar el Desempeño de la Gente",
      "Entrenar y Delegar",
      "Proporcionar Información Clara",
      "Manejar el Tiempo y Priorizar",
      "Tomar Decisiones y Ponderar Riesgos",
      "Establecer Metas y Objetivos",
      "Pensar Clara y Juiciosamente",
    ];
    let htmlPages: Element[] = Array.prototype.slice.call(
      document.querySelectorAll(".report-page-to-print")
    );
    const guideWrappers = document.querySelectorAll(
      ".generic-separator-comparative-report"
    );
    if (guideWrappers.length === 2 && this.skillsSingle.length >= 2) {
      const blockIndex = (name: string) =>
        guideBlockDomOrder.findIndex((key) => name.includes(key));
      if (
        blockIndex(this.skillsSingle[0].name) >
        blockIndex(this.skillsSingle[1].name)
      ) {
        const secondGuidePages = htmlPages.filter((p) =>
          guideWrappers[0].contains(p)
        );
        const firstGuidePages = htmlPages.filter((p) =>
          guideWrappers[1].contains(p)
        );
        const reordered: Element[] = [];
        htmlPages.forEach((p) => {
          if (firstGuidePages.indexOf(p) !== -1) return;
          if (p === secondGuidePages[0]) {
            reordered.push.apply(reordered, firstGuidePages);
          }
          reordered.push(p);
        });
        htmlPages = reordered;
      }
    }
    // setPagesDynamically numbers footers by DOM position; renumber by the
    // actual print order so reordered guide pages keep correct page numbers.
    htmlPages.forEach((pageEl, index) => {
      if (index === 0) {
        return;
      }
      pageEl
        .querySelectorAll(
          ".generic-top-page.anima-valign-text-middle, .report-page-footer--decorator"
        )
        .forEach((el) => {
          if ((el as HTMLElement).offsetParent !== null) {
            el.textContent = (index + 1).toString();
          }
        });
    });

    for (let i = 0; i < htmlPages.length; i++) {
      const pageEl = htmlPages[i] as HTMLElement;
      const canvas = await html2canvas(pageEl, {
        useCORS: true, // Enable cross-origin images
        scale: 2, // Higher scale for better quality
        onclone: (document) => {
          // Ensuring fonts are loaded
          document.fonts.ready;
        },
      });

      const imgData = canvas.toDataURL("image/jpeg", 1.0);
      const imgWidth = pdfDoc.internal.pageSize.getWidth();
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdfDoc.addImage(imgData, "JPEG", 0, 0, imgWidth, imgHeight);

      // The page is rasterized, so anchors aren't clickable. Re-add each link
      // as a real PDF annotation positioned over the same spot.
      const pageRect = pageEl.getBoundingClientRect();
      const mmPerPx = imgWidth / pageRect.width;
      pageEl.querySelectorAll("a[href]").forEach((anchor) => {
        const a = anchor as HTMLAnchorElement;
        const r = a.getBoundingClientRect();
        pdfDoc.link(
          (r.left - pageRect.left) * mmPerPx,
          (r.top - pageRect.top) * mmPerPx,
          r.width * mmPerPx,
          r.height * mmPerPx,
          { url: a.href }
        );
      });

      if (i < htmlPages.length - 1) {
        pdfDoc.addPage(); // Add a new page for the next image
      }
    }

    pdfDoc.save(
      `${this.name}-${this.surname}-${this.companyName}-MAP-Reporte-Comparativo.pdf`
    ); // Save the final PDF after all pages are processed
  }

  getPercentageBarWidth() {
    const _ = this;

    _.defaultMaxBarWidth = 297;

    _.barWidthPercentage1 = (_.skillSingle1 * _.defaultMaxBarWidth) / 100;
    _.barPercentage1 = _.barWidthPercentage1 + _.leftDefault;
    _.barWidthPercentage2 = (_.skillSingle2 * _.defaultMaxBarWidth) / 100;
    _.barPercentage2 = _.barWidthPercentage2 + _.leftDefault;
    _.barWidthPercentage3 = (_.skillSingle3 * _.defaultMaxBarWidth) / 100;
    _.barPercentage3 = _.barWidthPercentage3 + _.leftDefault;
    _.barWidthPercentage4 = (_.skillSingle4 * _.defaultMaxBarWidth) / 100;
    _.barPercentage4 = _.barWidthPercentage4 + _.leftDefault;
    _.barWidthPercentage5 = (_.skillSingle5 * _.defaultMaxBarWidth) / 100;
    _.barPercentage5 = _.barWidthPercentage5 + _.leftDefault;
    _.barWidthPercentage6 = (_.skillSingle6 * _.defaultMaxBarWidth) / 100;
    _.barPercentage6 = _.barWidthPercentage6 + _.leftDefault;
    _.barWidthPercentage7 = (_.skillSingle7 * _.defaultMaxBarWidth) / 100;
    _.barPercentage7 = _.barWidthPercentage7 + _.leftDefault;
    _.barWidthPercentage8 = (_.skillSingle8 * _.defaultMaxBarWidth) / 100;
    _.barPercentage8 = _.barWidthPercentage8 + _.leftDefault;
    _.barWidthPercentage9 = (_.skillSingle9 * _.defaultMaxBarWidth) / 100;
    _.barPercentage9 = _.barWidthPercentage9 + _.leftDefault;
    _.barWidthPercentage10 = (_.skillSingle10 * _.defaultMaxBarWidth) / 100;
    _.barPercentage10 = _.barWidthPercentage10 + _.leftDefault;
    _.barWidthPercentage11 = (_.skillSingle11 * _.defaultMaxBarWidth) / 100;
    _.barPercentage11 = _.barWidthPercentage11 + _.leftDefault;
    _.barWidthPercentage12 = (_.skillSingle12 * _.defaultMaxBarWidth) / 100;
    _.barPercentage12 = _.barWidthPercentage12 + _.leftDefault;
    _.barWidthPercentage13 = (_.skillSingle13 * 275) / 100;
    _.barPercentage13 = _.barWidthPercentage13 + _.leftDefault;
    _.barWidthPercentage14 = (_.skillSingle14 * 275) / 100;
    _.barPercentage14 = _.barWidthPercentage14 + _.leftDefault;
    _.barWidthPercentageEffectiveness =
      (_.averageEffectiveness * _.defaultMaxBarWidth) / 100;
    _.barPercentageEffectiveness =
      _.barWidthPercentageEffectiveness + _.leftDefault;

    const defaultMaxBarWidthBrecha = 180;
    const leftDefaultBrecha = 255;
    _.barWidthPercentageBrecha1 =
      (_.skillSingle1 * defaultMaxBarWidthBrecha) / 100;
    _.barPercentageBrecha1 = _.barWidthPercentageBrecha1 + leftDefaultBrecha;
    _.barWidthPercentageBrecha2 =
      (_.skillSingle2 * defaultMaxBarWidthBrecha) / 100;
    _.barPercentageBrecha2 = _.barWidthPercentageBrecha2 + leftDefaultBrecha;
    _.barWidthPercentageBrecha3 =
      (_.skillSingle3 * defaultMaxBarWidthBrecha) / 100;
    _.barPercentageBrecha3 = _.barWidthPercentageBrecha3 + leftDefaultBrecha;

    _.barWidthPercentageBrecha4 =
      (_.skillSingle4 * defaultMaxBarWidthBrecha) / 100;
    _.barPercentageBrecha4 = _.barWidthPercentageBrecha4 + leftDefaultBrecha;
    _.barWidthPercentageBrecha5 =
      (_.skillSingle5 * defaultMaxBarWidthBrecha) / 100;
    _.barPercentageBrecha5 = _.barWidthPercentageBrecha5 + leftDefaultBrecha;
    _.barWidthPercentageBrecha6 =
      (_.skillSingle6 * defaultMaxBarWidthBrecha) / 100;
    _.barPercentageBrecha6 = _.barWidthPercentageBrecha6 + leftDefaultBrecha;

    _.barWidthPercentageBrecha7 =
      (_.skillSingle7 * defaultMaxBarWidthBrecha) / 100;
    _.barPercentageBrecha7 = _.barWidthPercentageBrecha7 + leftDefaultBrecha;
    _.barWidthPercentageBrecha8 =
      (_.skillSingle8 * defaultMaxBarWidthBrecha) / 100;
    _.barPercentageBrecha8 = _.barWidthPercentageBrecha8 + leftDefaultBrecha;
    _.barWidthPercentageBrecha9 =
      (_.skillSingle9 * defaultMaxBarWidthBrecha) / 100;
    _.barPercentageBrecha9 = _.barWidthPercentageBrecha9 + leftDefaultBrecha;

    _.barWidthPercentageBrecha10 =
      (_.skillSingle10 * defaultMaxBarWidthBrecha) / 100;
    _.barPercentageBrecha10 = _.barWidthPercentageBrecha10 + leftDefaultBrecha;
    _.barWidthPercentageBrecha11 =
      (_.skillSingle11 * defaultMaxBarWidthBrecha) / 100;
    _.barPercentageBrecha11 = _.barWidthPercentageBrecha11 + leftDefaultBrecha;
    _.barWidthPercentageBrecha12 =
      (_.skillSingle12 * defaultMaxBarWidthBrecha) / 100;
    _.barPercentageBrecha12 = _.barWidthPercentageBrecha12 + leftDefaultBrecha;

    const defaultMaxBarWidthIdeal = 180;
    const leftDefaultIdeal = 255;
    _.barWidthPercentageIdeal1 = (_.skill0 * defaultMaxBarWidthIdeal) / 100;
    _.barPercentageIdeal1 = _.barWidthPercentageIdeal1 + leftDefaultIdeal;
    _.barWidthPercentageIdeal2 = (_.skill1 * defaultMaxBarWidthIdeal) / 100;
    _.barPercentageIdeal2 = _.barWidthPercentageIdeal2 + leftDefaultIdeal;
    _.barWidthPercentageIdeal3 = (_.skill2 * defaultMaxBarWidthIdeal) / 100;
    _.barPercentageIdeal3 = _.barWidthPercentageIdeal3 + leftDefaultIdeal;

    _.barWidthPercentageIdeal4 = (_.skill3 * defaultMaxBarWidthIdeal) / 100;
    _.barPercentageIdeal4 = _.barWidthPercentageIdeal4 + leftDefaultIdeal;
    _.barWidthPercentageIdeal5 = (_.skill4 * defaultMaxBarWidthIdeal) / 100;
    _.barPercentageIdeal5 = _.barWidthPercentageIdeal5 + leftDefaultIdeal;
    _.barWidthPercentageIdeal6 = (_.skill6 * defaultMaxBarWidthIdeal) / 100;
    _.barPercentageIdeal6 = _.barWidthPercentageIdeal6 + leftDefaultIdeal;

    _.barWidthPercentageIdeal7 = (_.skill5 * defaultMaxBarWidthIdeal) / 100;
    _.barPercentageIdeal7 = _.barWidthPercentageIdeal7 + leftDefaultIdeal;
    _.barWidthPercentageIdeal8 = (_.skill7 * defaultMaxBarWidthIdeal) / 100;
    _.barPercentageIdeal8 = _.barWidthPercentageIdeal8 + leftDefaultIdeal;
    _.barWidthPercentageIdeal9 = (_.skill8 * defaultMaxBarWidthIdeal) / 100;
    _.barPercentageIdeal9 = _.barWidthPercentageIdeal9 + leftDefaultIdeal;

    _.barWidthPercentageIdeal10 = (_.skill9 * defaultMaxBarWidthIdeal) / 100;
    _.barPercentageIdeal10 = _.barWidthPercentageIdeal10 + leftDefaultIdeal;
    _.barWidthPercentageIdeal11 = (_.skill10 * defaultMaxBarWidthIdeal) / 100;
    _.barPercentageIdeal11 = _.barWidthPercentageIdeal11 + leftDefaultIdeal;
    _.barWidthPercentageIdeal12 = (_.skill11 * defaultMaxBarWidthIdeal) / 100;
    _.barPercentageIdeal12 = _.barWidthPercentageIdeal12 + leftDefaultIdeal;
  }
  // This method set dynamically page numbers.
  // If you remover or add another page... You need to modify this.
  setPagesDynamically() {
    // Wait for DOM to be fully rendered with conditional sections
    setTimeout(() => {
      // Select all visible page elements that are actually rendered
      const allPageElements = document.querySelectorAll(
        ".report-page-to-print"
      );
      
      let pageNumber = 1;
      
      allPageElements.forEach((pageElement, index) => {
        // Skip page 1 - no pagination on first page
        if (index === 0) {
          pageNumber++;
          return;
        }
        
        // Find page number elements within this page
        const pageNumberElements = pageElement.querySelectorAll(
          ".generic-top-page.anima-valign-text-middle, .report-page-footer--decorator"
        );
        
        pageNumberElements.forEach((element) => {
          // Only update if the element is visible (not hidden by v-if)
          const htmlElement = element as HTMLElement;
          if (htmlElement.offsetParent !== null) {
            element.textContent = pageNumber.toString();
          }
        });
        
        pageNumber++;
      });
    }, 100);
  }

  getChromeVersion() {
    const userAgent = navigator.userAgent;
    const chromeIndex = userAgent.indexOf("Chrome");

    if (chromeIndex !== -1) {
      const version = userAgent.substring(chromeIndex + 7).split(" ")[0];
      const formattedVersion = parseInt(version);
      return formattedVersion;
    }
    return null;
  }
}
